import {
	getHealthMonitoring,
	getLinshiList,
	getZuzhiList,
	getRenyuanList,
	editRenyuanById,
	delRenyuanById,
	addRenyuan,
	getRenyuanDetail,
	delZuzhiById,
	getAddressList,
	getAddressTree,
	delAddressById,
	editAddressById,
	addAddress,
	getZuzhiTree,
	addZuzhi,
	editZuzhiById,
	getZhanghuList,
	delZhanghuById,
	saveRenyuanPhoto,
	getToken,
	getCust,
	getCustAlls,
	custCard,
	xiuCustCard,
	faka,
	delcust,
	getCustAll,
	delcustall,
	butieChongzhi,
	moneyChongzhi,
	getPosition,
	delPosition,
	editPosition,
	addPosition,
	getSick,
	delSick,
	editSick,
	addSick,
	getAllPosition,
	getAllSick,
	qukuan,
	dongjie,
	jiedong,
	guashi,
	jiegua,
	guashis,
	jieguas,
	huanka,
	fuhuanka,
	banka,
	delButieRules,
	getButieRules,
	getNewButieRules,
	editButieRules,
	editNewButieRules,
	addButieRules,
	addNewButieRules,
	uploadExcel,
	queryPageRecharge,
	personRecharge,
	orgRecharge,
	exportRecharge,
	addPsnType,
	editPsnType,
	getPsnType,
	saveCustPhotoUnion,
	orgRechargeSub,
	personalRechargeSub,
	tuikuan,
	tuikuanjilu,
	changeBaseInfo,
	delPersonall,
	bukou,
	tuidan,
	getShebeis,
	accbatchsubsidy,
	getchognzhiJieguo,
	getbutieHistory,
	accsubsidy,
	pldaoruResult,
	addCardbind,
	getCardbind,
	delCardbind,
	exportCardbinds,
	plEditorg,
	plEditcust,
	queryPageAccCardDeductionHist,
	plEditbatchPerAccBalanceLimit,
	pldaorupersonkou,
	pldaoruyichang,
	getZhuanzhangtradeTypeEnum,
	getChongzhitradeTypeEnum,
	getQukuantradeTypeEnumNew,
	pldaoruRenlian,
	personalLogOut,
	uploadeditExcel,
	getAlltradetype,
	exportPlbukouyichang,
	getBukouamount,
	unfreeze,
	downloadAllPlace
} from '@/api/personal'
// import { getToken } from '@/utils/auth'

const findFromArr = (arr, fn) => {
	// fn: item => item.id === '213'
	let obj = null
	arr.forEach(item => {
		if (fn(item)) {
			obj = item
			return false
		} else if (item.children && item.children.length) {
			const tmpObj = findFromArr(item.children, fn)
			if (tmpObj) obj = tmpObj
		}
	})
	return obj
}

const state = {
	orgData: []
}
const mutations = {
	getOrgs (state, preload) {
		state.orgData = preload
	},
	addOrg (state, preload) {
		const node = findFromArr(
			state.orgData,
			({ superId }) => superId === preload.superId
		)
		if (node) {
			if (node.children) node.children.push(preload)
			else node.children = [preload]
		}
	},
	updateOrg (state, { orgId, orgName }) {
		const node = findFromArr(state.orgData, ({ id }) => id === orgId)
		if (node) Object.assign(node, { text: orgName })
	},
	deleteOrg (state, preload) {
		const parent = findFromArr(
			state.orgData,
			({ id }) => id === preload.superId
		)
		parent.children.splice(
			parent.children.findIndex(({ id }) => id === preload.orgId),
			1
		)
	}
}

const actions = {
	unfreeze ({}, data) {
		return new Promise((resolve, reject) => {
			unfreeze(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	personalLogOut ({}, data) {
		return new Promise((resolve, reject) => {
			personalLogOut(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	pldaoruRenlian ({}, data) {
		return new Promise((resolve, reject) => {
			pldaoruRenlian(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	pldaoruResult ({}, data) {
		return new Promise((resolve, reject) => {
			pldaoruResult(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	accsubsidy ({}, data) {
		return new Promise((resolve, reject) => {
			accsubsidy(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	getbutieHistory ({}, data) {
		return new Promise((resolve, reject) => {
			getbutieHistory(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	getchognzhiJieguo ({}, data) {
		return new Promise((resolve, reject) => {
			getchognzhiJieguo(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},

	accbatchsubsidy ({}, data) {
		return new Promise((resolve, reject) => {
			accbatchsubsidy(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	// 获取设备
	getShebeis ({}, data) {
		return new Promise((resolve, reject) => {
			getShebeis(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	bukou ({}, data) {
		return new Promise((resolve, reject) => {
			bukou(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	tuidan ({}, data) {
		return new Promise((resolve, reject) => {
			tuidan(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	tuikuan ({}, data) {
		return new Promise((resolve, reject) => {
			tuikuan(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	delButieRules ({}, data) {
		return new Promise((resolve, reject) => {
			delButieRules(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	getButieRules ({}, data) {
		return new Promise((resolve, reject) => {
			getButieRules(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	getNewButieRules ({}, data) {
		return new Promise((resolve, reject) => {
			getNewButieRules(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	editButieRules ({}, data) {
		return new Promise((resolve, reject) => {
			editButieRules(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	editNewButieRules ({}, data) {
		return new Promise((resolve, reject) => {
			editNewButieRules(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	addNewButieRules ({}, data) {
		return new Promise((resolve, reject) => {
			addNewButieRules(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	addButieRules ({}, data) {
		return new Promise((resolve, reject) => {
			addButieRules(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	banka ({}, data) {
		return new Promise((resolve, reject) => {
			banka(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	huanka ({}, data) {
		return new Promise((resolve, reject) => {
			huanka(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	fuhuanka ({}, data) {
		return new Promise((resolve, reject) => {
			fuhuanka(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	jiegua ({}, data) {
		return new Promise((resolve, reject) => {
			jiegua(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	guashi ({}, data) {
		return new Promise((resolve, reject) => {
			guashi(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	jieguas ({}, data) {
		return new Promise((resolve, reject) => {
			jieguas(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	guashis ({}, data) {
		return new Promise((resolve, reject) => {
			guashis(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	jiedong ({}, data) {
		return new Promise((resolve, reject) => {
			jiedong(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	dongjie ({}, data) {
		return new Promise((resolve, reject) => {
			dongjie(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	qukuan ({}, data) {
		return new Promise((resolve, reject) => {
			qukuan(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	getAllSick ({}, data) {
		return new Promise((resolve, reject) => {
			getAllSick(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	getAllPosition ({}, data) {
		return new Promise((resolve, reject) => {
			getAllPosition(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	getSick ({}, data) {
		return new Promise((resolve, reject) => {
			getSick(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	editSick ({}, data) {
		return new Promise((resolve, reject) => {
			editSick(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	delSick ({}, data) {
		return new Promise((resolve, reject) => {
			delSick(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	addSick ({}, data) {
		return new Promise((resolve, reject) => {
			addSick(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	getPosition ({}, data) {
		return new Promise((resolve, reject) => {
			getPosition(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	editPosition ({}, data) {
		return new Promise((resolve, reject) => {
			editPosition(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	delPosition ({}, data) {
		return new Promise((resolve, reject) => {
			delPosition(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	addPosition ({}, data) {
		return new Promise((resolve, reject) => {
			addPosition(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	moneyChongzhi ({}, data) {
		return new Promise((resolve, reject) => {
			moneyChongzhi(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	butieChongzhi ({}, data) {
		return new Promise((resolve, reject) => {
			butieChongzhi(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	getCust ({}, data) {
		return new Promise((resolve, reject) => {
			getCust(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	getCustAll ({}, data) {
		return new Promise((resolve, reject) => {
			getCustAll(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	custCard ({}, data) {
		return new Promise((resolve, reject) => {
			custCard(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	xiuCustCard ({}, data) {
		return new Promise((resolve, reject) => {
			xiuCustCard(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	faka ({}, data) {
		return new Promise((resolve, reject) => {
			faka(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	delcust ({}, data) {
		return new Promise((resolve, reject) => {
			delcust(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	getCustAlls ({}, data) {
		return new Promise((resolve, reject) => {
			getCustAlls(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	delcustall ({}, data) {
		return new Promise((resolve, reject) => {
			delcustall(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	getToken ({}, data) {
		return new Promise((resolve, reject) => {
			getToken(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	saveRenyuanPhoto ({}, data) {
		return new Promise((resolve, reject) => {
			saveRenyuanPhoto(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	delZhanghuById ({}, data) {
		return new Promise((resolve, reject) => {
			delZhanghuById(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	getZhanghuList ({}, data) {
		return new Promise((resolve, reject) => {
			getZhanghuList(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	addRenyuan ({}, data) {
		return new Promise((resolve, reject) => {
			addRenyuan(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	delRenyuanById ({}, data) {
		return new Promise((resolve, reject) => {
			delRenyuanById(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	editRenyuanById ({}, data) {
		return new Promise((resolve, reject) => {
			editRenyuanById(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	getLinshiList ({}, data) {
		return new Promise((resolve, reject) => {
			getLinshiList(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	getZuzhiList ({}, data) {
		return new Promise((resolve, reject) => {
			getZuzhiList(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	getZuzhiTree ({ state, commit }, data) {
		return new Promise((resolve, reject) => {
			if (state.orgData.length && (data ? !data.isNew : true)) { return resolve(state.orgData) }
			if (data && data.hasOwnProperty.call('isNew')) delete data.isNew
			getZuzhiTree(data)
				.then(res => {
					console.log(res)
					commit('getOrgs', res)
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	addZuzhi ({ commit }, data) {
		return new Promise((resolve, reject) => {
			addZuzhi(data)
				.then(res => {
					// 需后端返回新增数据
					// commit('addOrg', data)
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	delZuzhiById ({ commit }, data) {
		return new Promise((resolve, reject) => {
			delZuzhiById(data)
				.then(res => {
					commit('deleteOrg', data)
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	editZuzhiById ({ commit }, data) {
		return new Promise((resolve, reject) => {
			editZuzhiById(data)
				.then(res => {
					commit('updateOrg', data)
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	getAddressList ({}, data) {
		return new Promise((resolve, reject) => {
			getAddressList(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	getAddressTree ({}, data) {
		return new Promise((resolve, reject) => {
			getAddressTree(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	editAddressById ({}, data) {
		return new Promise((resolve, reject) => {
			editAddressById(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	delAddressById ({}, data) {
		return new Promise((resolve, reject) => {
			delAddressById(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	addAddress ({}, data) {
		return new Promise((resolve, reject) => {
			addAddress(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	getRenyuanList ({}, data) {
		return new Promise((resolve, reject) => {
			getRenyuanList(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	getHealthMonitoring ({}, data) {
		return new Promise((resolve, reject) => {
			getHealthMonitoring(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	getRenyuanDetail ({}, data) {
		return new Promise((resolve, reject) => {
			getRenyuanDetail(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},

	uploadExcel ({}, data) {
		return new Promise((resolve, reject) => {
			uploadExcel(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},

	queryPageRecharge ({}, data) {
		return new Promise((resolve, reject) => {
			queryPageRecharge(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	personRecharge ({}, data) {
		return new Promise((resolve, reject) => {
			personRecharge(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	orgRecharge ({}, data) {
		return new Promise((resolve, reject) => {
			orgRecharge(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	exportRecharge ({}, data) {
		return new Promise((resolve, reject) => {
			exportRecharge(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	addPsnType ({}, data) {
		return new Promise((resolve, reject) => {
			addPsnType(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	editPsnType ({}, data) {
		return new Promise((resolve, reject) => {
			editPsnType(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	saveCustPhotoUnion ({}, data) {
		return new Promise((resolve, reject) => {
			saveCustPhotoUnion(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	getPsnType ({}, data) {
		return new Promise((resolve, reject) => {
			getPsnType(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	orgRechargeSub ({}, data) {
		return new Promise((resolve, reject) => {
			orgRechargeSub(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	personalRechargeSub ({}, data) {
		return new Promise((resolve, reject) => {
			personalRechargeSub(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	tuikuanjilu ({}, data) {
		return new Promise((resolve, reject) => {
			tuikuanjilu(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	changeBaseInfo ({}, data) {
		return new Promise((resolve, reject) => {
			changeBaseInfo(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	delPersonall ({}, data) {
		return new Promise((resolve, reject) => {
			delPersonall(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	addCardbind ({}, data) {
		return new Promise((resolve, reject) => {
			addCardbind(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	getCardbind ({}, data) {
		return new Promise((resolve, reject) => {
			getCardbind(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	delCardbind ({}, data) {
		return new Promise((resolve, reject) => {
			delCardbind(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	exportCardbinds ({}, data) {
		return new Promise((resolve, reject) => {
			exportCardbinds(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	plEditorg ({}, data) {
		return new Promise((resolve, reject) => {
			plEditorg(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	plEditcust ({}, data) {
		return new Promise((resolve, reject) => {
			plEditcust(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	queryPageAccCardDeductionHist ({}, data) {
		return new Promise((resolve, reject) => {
			queryPageAccCardDeductionHist(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	pldaorupersonkou ({}, data) {
		return new Promise((resolve, reject) => {
			pldaorupersonkou(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	plEditbatchPerAccBalanceLimit ({}, data) {
		return new Promise((resolve, reject) => {
			plEditbatchPerAccBalanceLimit(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	pldaoruyichang ({}, data) {
		return new Promise((resolve, reject) => {
			pldaoruyichang(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	getZhuanzhangtradeTypeEnum ({}, data) {
		return new Promise((resolve, reject) => {
			getZhuanzhangtradeTypeEnum(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	getChongzhitradeTypeEnum ({}, data) {
		return new Promise((resolve, reject) => {
			getChongzhitradeTypeEnum(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	getQukuantradeTypeEnumNew ({}, data) {
		return new Promise((resolve, reject) => {
			getQukuantradeTypeEnumNew(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},

	uploadeditExcel ({}, data) {
		return new Promise((resolve, reject) => {
			uploadeditExcel(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	getAlltradetype ({}, data) {
		return new Promise((resolve, reject) => {
			getAlltradetype(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	exportPlbukouyichang ({}, data) {
		return new Promise((resolve, reject) => {
			exportPlbukouyichang(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	getBukouamount ({}, data) {
		return new Promise((resolve, reject) => {
			getBukouamount(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	downloadAllPlace ({}, data) {
		return new Promise((resolve, reject) => {
			downloadAllPlace(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	}
}

export default {
	namespaced: true,
	state,
	mutations,
	actions
}
